import { combineReducers } from 'redux'

import notes from './notes'
import orders from './orders'
import quotes from './quotes'
import samples from './samples'

export default combineReducers({
  notes,
  orders,
  quotes,
  samples
})
